import React from 'react';
import { useParams } from 'react-router-dom';
import PeriodPassDetailLayout from './components/period_pass_detail_layout';

const PeriodPassDetail = () => {
    const { period_pass_id, } = useParams();
    return (
        <>
            <PeriodPassDetailLayout period_pass_id={period_pass_id} />
        </>
    );
}

export default PeriodPassDetail;
